module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk og engelsk_primaerlogo_pos(svart).93b9b8bb.svg";